"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.chatReducer = void 0;
const action_type_1 = __importDefault(require("../const/action-type"));
const initial_1 = __importDefault(require("@app/store/initial"));
const chatReducer = (state = initial_1.default.chat, action) => {
    switch (action.type) {
        case action_type_1.default.SET_CHAT_UNREAD_MESSAGES:
            return { unread: action.payload };
        default:
            return state;
    }
};
exports.chatReducer = chatReducer;
exports.default = exports.chatReducer;
